import { FC, useCallback, useEffect, useRef, useState } from "react";

import IProfessionistaProps from "pages/Prenotazione/Form/Professionista/IProfessionistaProps";

import { ProfessionistiRepository } from "core/data/index";

import { IGetProfessionistiRequest, IProfessionista } from "core/interfaces/data/IProfessionistiRequest";

import { Skeleton, Alert } from "antd";
import { CustomButton } from "core/interfaces/components/index";

import "./Professionista.css";
import { setProfessionista } from "core/redux/features/dataForm/dataFormSlice";
import { useAppSelector } from "core/redux/store/hooks";

import { formStep } from "types/StepEnums";
import { performAsyncFunction } from "utils/AsyncFunctionUtility";
import { CustomButtonType } from "components/CustomButton/CustomButtonType";
import NavigationManager from "utils/NavigationManager";
import { HSBTipoRicercaRisorsaUmanaEnum } from "types/HSBTipoRicercaRisorsaUmanaEnum";
import { selectParametri } from "core/redux/features/parametri/parametriSlice";
import { Enhanced } from "utils/ReactUtils";
import SceltaProfessionista from "components/SceltaProfessionista/SceltaProfessionista";

const Professionista: FC<IProfessionistaProps> = ({ i18n, t, dataForm, sessionInfo, handleError, dispatch, location }) => {
	const startRef: any = useRef(); // aggiunta $ALC

	const parametriInfo = useAppSelector(selectParametri);

	const { MoveStep } = NavigationManager(sessionInfo);

	const [professionisti, setProfessionisti] = useState<IProfessionista[] | undefined>(undefined);
	const [loading, setLoading] = useState<boolean>(true);

	//aggiunta $ALC
	const [selezioni, setSelezioni] = useState<boolean[]>([]);
	const [listaSceltaProfessionisti, setListaSceltaProfessionsiti] = useState<JSX.Element[]>([]);
	const [professionistaScelto, setProfessionistaScelto] = useState<IProfessionista>();

	const clickProfessionista = useCallback(
		(id: number) => {
			if (professionisti) {
				let selezionato = professionisti.find((el: IProfessionista) => el.IdOperatore === id);
				if (selezionato !== undefined) {
					setProfessionistaScelto({
						IdOperatore: selezionato.IdOperatore,
						DsOperatore: selezionato.DsOperatore,
						Generico: selezionato.Generico,
					});
					setSelezioni((prev: boolean[]) => {
						const next = [...prev];
						for (let i = 0; i < prev.length; i++) {
							if (professionisti[i].IdOperatore === id) next[i] = true;
							else next[i] = false;
						}
						return next;
					});
				}
			}
		},
		[professionisti]
	);
	const clickNoPreferenze = useCallback(() => {
		setSelezioni(new Array(professionisti?.length).fill(false));
		setProfessionistaScelto({
			IdOperatore: -1,
			DsOperatore: t("professionista.noPref"),
			Generico: true,
		});
	}, [professionisti?.length, t]);
	const buildProfessionistList = useCallback(() => {
		if (professionisti !== undefined) {
			const list = [];
			for (let [i, p] of professionisti.entries()) {
				list.push(
					<SceltaProfessionista
						key={"professionista-" + i}
						selected={selezioni[i]}
						OnClick={clickProfessionista}
						dsOperatore={p.DsOperatore}
						idOperatore={p.IdOperatore}
					></SceltaProfessionista>
				);
			}
			setListaSceltaProfessionsiti(list);
		} else setListaSceltaProfessionsiti([]);
	}, [clickProfessionista, professionisti, selezioni]);

	useEffect(() => {
		if (professionisti) {
			if (dataForm.professionista) {
				setProfessionistaScelto(dataForm.professionista);

				const list = [];
				for (let p of professionisti) {
					if (p.IdOperatore === dataForm.professionista.IdOperatore) {
						list.push(true);
					} else list.push(false);
				}
				setSelezioni(list);
			} else {
				setSelezioni(Array(professionisti.length).fill(false));
			}
		} else {
			setSelezioni([]);
		}
	}, [dataForm.professionista, professionisti]);
	useEffect(() => {
		buildProfessionistList();
	}, [buildProfessionistList]);

	const clickSubmit = () => {
		if (!professionistaScelto) {
			return;
		}

		if (professionisti) {
			SetProfessionista(professionistaScelto);
		}
	};

	const SetProfessionista = useCallback(
		(professionista: IProfessionista, replace?: boolean) => {
			// console.log("SET PROFESSIONISTA")
			dispatch(setProfessionista(professionista));
			MoveStep("next", replace);
		},
		[MoveStep, dispatch]
	);

	// const NoPreferences = useCallback(
	// 	(replace?: boolean) => {
	// 		SetProfessionista(
	// 			{
	// 				IdOperatore: -1,
	// 				DsOperatore: t("professionista.noPref"),
	// 				Generico: true,
	// 			},
	// 			replace
	// 		);
	// 		return;
	// 	},
	// 	[SetProfessionista, t]
	// );

	// const movePrev = useCallback(async () => {
	// 	MoveStep("prev");
	// }, [MoveStep]);


	useEffect(() => {
		performAsyncFunction(async () => {
			setLoading(true);

			if (parametriInfo && parametriInfo.HSBTipoRicercaRisorsaUmana === HSBTipoRicercaRisorsaUmanaEnum.Generiche) {
				// console.log("NON scelgo professionista")
				if (Number.parseInt(location.state.from.state.newStep ?? "0") > formStep.Professionista) {
					//questo si verifica tornando indietro dalla scelta data?
					// console.log("PREV")
					MoveStep("prev");
				} else {
					// console.log("NO PREF")
					// NoPreferences(true);
					SetProfessionista({
						IdOperatore: -1,
						DsOperatore: t("professionista.noPref"),
						Generico: true,
					},false)
				}
			} else {
				// console.log("scelgo professionista")
				var professionistiProps: IGetProfessionistiRequest = {
					IdEquipe: dataForm.area?.IdEquipe!,
					CodGruppo: dataForm.area?.CodGruppo!,
					IguAttivita: dataForm.prestazione?.IguAttivita!,
					culture: i18n.language,
					IdSessione: sessionInfo.sessione?.idSessione!,
					step: sessionInfo.step as number,
				};
				let data = await ProfessionistiRepository.getProfessionisti(professionistiProps);

				setProfessionisti(data);
			}
			setLoading(false);
		}, handleError);
	}, [MoveStep, SetProfessionista, dataForm.area?.CodGruppo, dataForm.area?.IdEquipe, dataForm.prestazione?.IguAttivita, handleError, i18n.language, location.state.from.state.newStep, parametriInfo, sessionInfo.sessione?.idSessione, sessionInfo.step, t]);

	useEffect(() => {
		//aggiunt $ALC
		if (startRef.current) startRef.current.focus();
	}, [professionisti]);

	if (loading) {
		return <Skeleton active />;
	}

	return (
		<div id="professionisti" role="main" aria-label="Step 4">
			{/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
			<div className="title item" tabIndex={0} ref={startRef}>
				<span>{t("professionista.title")}</span>
			</div>
			<div className="text item">
				<span>{t("professionista.text")}</span>
			</div>
			{professionisti ? (
				<>
					{professionisti.length !== 0 ? (
						<div className={"professionisti-list"}>
							<SceltaProfessionista
								noPref={true}
								selected={professionistaScelto !== undefined && professionistaScelto.IdOperatore === -1}
								OnClick={clickNoPreferenze}
								dsOperatore={t("no-preferenze")}
								idOperatore={-1}
							></SceltaProfessionista>

							{listaSceltaProfessionisti}
						</div>
					) : (
						<div style={{ textAlign: "center" }}>
							<p style={{ margin: "2em auto" }}>{t("professionista.notFound")}</p>
						</div>
					)}
				</>
			) : (
				<Alert message={t("errorMessages.base")} type="error" showIcon banner />
			)}
			<div className="button-box item">
				<CustomButton text={t("backButton")} OnClick={() => MoveStep("prev")} buttonType={CustomButtonType.negative} />
				<CustomButton
					text={t("professionista.button")}
					buttonType={CustomButtonType.positive}
					enabled={professionistaScelto !== undefined}
					OnClick={clickSubmit}
				/>
			</div>
		</div>
	);
};

export default Enhanced(Professionista, { componentNamespace: "Professionista" });
